import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    useTab,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_APRVAPP_DTL,
    SF_APP_RGST_VRFN_RSLT,
    SG_APP_DTL_INSC_ATCM,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import { APP_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_GEN";
import { APP_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_TRPT";
import { APP_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_INVC";
import { APP_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ITM";
import { APP_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ATCM";
import { APP_DTL_PAY_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_PAY_INFO";
import { APP_DTL_MSG } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_MSG";
import { APP_DTL_DCLR } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_DCLR";
import { APIS_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppOfcrAddItmService";

/**
 * LPCO Application Verification Detail for Approval
 * !== 결재를 위한 LPCO 신청서 심사 상세 ==!
 */
export const OSCI0201029Q = (props: any) => {
    // 2026-05-07 KNH: !== 컴포넌트 리소스 정의 ==!
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0131" }, // 신청서 상태 코드
            { area: "comnCd", comnCd: "OSC0142" }, // 신청서 상태 변경 코드
        ],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const { pgeUid, menuId, back } = usePage({
    // 2026-05-07 KNH: !== 결재를 위한 화면이므로 권한 체크 필요 없음 ==!
    // auth: ["auth_osci0006", "auth_osci0015"],
    // });
    const pgeUid = "OSCI0201029Q";

    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { appId } = useParams();

    const location = useLocation();
    const [param, setParam] = useState<any>({ ...(location.state ?? {}) });

    let tabSchemaList: any = [];

    const [gnrl, setGnrlVisible] = useState(false);
    const [trpt, setTrptVisible] = useState(false);
    const [invc, setInvcVisible] = useState(false);
    const [itm, setItmVisible] = useState(false);
    // Assignment officer type of the row being shown (VE/IP) !== 표시 중인 배정행의 담당자 유형 ==!
    const [asnmtOfcrTpCd, setAsnmtOfcrTpCd] = useState("");
    // Inspection attachment list (approval review, read-only) !== 검사 첨부파일 목록 (결재 열람 전용) ==!
    const [atcmList, setAtcmList] = useState(comnUtils.getGridData([]));
    const [atcm, setAtcmVisible] = useState(false);
    const [payInfo, setpayInfoVisible] = useState(false);
    const [msg, setMsgVisible] = useState(false);
    const [dclr, setDclrVisible] = useState(false);
    const [cfrm, setCfrmVisible] = useState(false);

    const [comnCdList, setComnCdList] = useState([]);

    const orgCd = auth.get("orgCd");

    /*
     * Application Detail Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Application Verification Result Form !== 신청서 심사 결과 Form ==!
        appRgstVrfnRslt: useForm({
            defaultSchema: SF_APP_RGST_VRFN_RSLT,
            defaultValues: {},
        }),
        // Application Ddtail Info Form !== 신청서 상세 정보 Form ==!
        newAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
            defaultValues: {
                // ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Pre-Application Tab
     * !== 탭 정의 ==!
     */
    const tab = {
        tabSchema: useTab({
            defaultSchema: {
                id: "tab",
                schema: tabSchemaList,
            },
        }),
    };

    const render = {
        tabView: () => {
            const tabPanelList: any = [];
            const tabList = comnCdList;
            if (tabList != undefined) {
                tabList.map((item: any) => {
                    if ("GEN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{gnrl && <APP_DTL_GEN state={param} />}</Tab.Panel>,
                        );
                    } else if ("TRN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{trpt && <APP_DTL_TRPT state={param} />}</Tab.Panel>,
                        );
                    } else if ("INV" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{invc && <APP_DTL_INVC state={param} />}</Tab.Panel>,
                        );
                    } else if ("ITM" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{itm && <APP_DTL_ITM state={param} />}</Tab.Panel>,
                        );
                    } else if ("ATC" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{atcm && <APP_DTL_ATCM state={param} />}</Tab.Panel>,
                        );
                    } else if ("PAY" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{payInfo && <APP_DTL_PAY_INFO state={param} />}</Tab.Panel>,
                        );
                    } else if ("MSG" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{msg && <APP_DTL_MSG state={param} />}</Tab.Panel>,
                        );
                    } else if ("DCL" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{dclr && <APP_DTL_DCLR state={param} />}</Tab.Panel>,
                        );
                    }
                });
            }
            return tabPanelList;
        },
    };

    /*
     * Inspection Attachment Grid
     * !== 검사 첨부파일 그리드 ==!
     */
    const grid = {
        appDtlInscAtcm: useGrid({
            defaultSchema: SG_APP_DTL_INSC_ATCM,
        }),
    };

    /*
     * Master Applidation Details Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppInfo: useFetch({
            api: (appId) => APIS.getAppInfo({ appId: appId, orgCd: auth.get("orgCd") }),
            onSuccess: (data) => {
                const content = data?.appInfo?.content ?? {};
                form.newAppDtl.setValues({ ...content });
                setParam({ ...content });
                handler.getTabSchemaList(content);
            },
            onError: (error) => {},
        }),
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppAprvInfo: useFetch({
            api: (appId) => APIS.getAppAprvInfo({ reffId: appId }),
            onSuccess: (data) => {
                const aprvInfo = data?.appAprvInfo?.content ?? {};
                form.appRgstVrfnRslt.setValues({ ...aprvInfo });
                setAsnmtOfcrTpCd(aprvInfo.asnmtOfcrTpCd);
                // Inspection step with inspected result carries attachments !== 검사 단계이고 결과가 검사면 첨부 조회 ==!
                if (aprvInfo.asnmtOfcrTpCd === "IP" && aprvInfo.prcssStatCd === "IP") {
                    fetch.getInscAtcmList.fetch(0);
                }
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        // Get Inspection Attachment List !== 검사 첨부파일 목록 조회 ==!
        getInscAtcmList: useFetch({
            api: (page = grid.appDtlInscAtcm.page) => {
                return APIS.getInscAtcmList({ ...param }, page, grid.appDtlInscAtcm.size);
            },
            key: [grid.appDtlInscAtcm.page, grid.appDtlInscAtcm.size],
            onSuccess: (data) => {
                if (data.atcmList.content!) {
                    setAtcmList(comnUtils.getGridData(data.atcmList.content));
                }
            },
            onError: () => {},
            showToast: false,
        }),
        getRprt: useFetch({
            api: () => {
                return lpcoUtils.getRprtLpco(
                    appId,
                    // ["AP", "CL"].indexOf(form.newAppDtl.getValue("appStatCd")) > -1 ? "N" : "Y",
                    "Y",
                );
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: useFetch({
            api: (appId, appStatCd) => {
                return APIS.updateReceived(appId, appStatCd);
            },
            onSuccess: (data, param) => {
                handler.setInit();
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
        }),
    };

    /*
     * Application Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await handler.getAppInfo(appId);
            await handler.getAppAprvInfo(appId);
            render.tabView();
        },
        // Get Pre-Application Information !== 사전신청서 정보 조회 ==!
        getAppInfo: async (appId: any) => {
            return fetch.getAppInfo.fetch(appId);
        },
        // Get Application Approval Information !== 신청서 결재 정보 조회 ==!
        getAppAprvInfo: async (appId: any) => {
            return fetch.getAppAprvInfo.fetch(appId);
        },
        getTabSchemaList: async (data: any) => {
            const reqParam = { orgCd: data.orgCd, appCdNo: data.appCdNo, appTpCd: data.appTpCd };
            const comnCdList = await lpcoUtils.getCpntList(reqParam);
            comnCdList.map((item: any) => {
                if ("CON" != item.value) {
                    tabSchemaList.push({ label: item.label });
                }
            });
            tab.tabSchema.setSchema(tabSchemaList);
            setComnCdList(comnCdList);

            handler.changeTab(0);
        },
        // Hide existing tab contents when changing tab !== Tab변경 시 기존 탭 내용 숨김처리  ==!
        chanageTabVisible: () => {
            setGnrlVisible(false);
            setTrptVisible(false);
            setInvcVisible(false);
            setItmVisible(false);
            setAtcmVisible(false);
            setCfrmVisible(false);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        changeTab: async (index: any) => {
            handler.chanageTabVisible();
            let tabList = comnCdList;
            if (tabList && tabList.length > 0) {
                const tabInfo: any = tabList[index];
                switch (tabInfo.value) {
                    case "GEN":
                        setGnrlVisible(true);
                        break;
                    case "TRN":
                        setTrptVisible(true);
                        break;
                    case "INV":
                        setInvcVisible(true);
                        break;
                    case "ITM":
                        setItmVisible(true);
                        break;
                    case "ATC":
                        setAtcmVisible(true);
                        break;
                    case "PAY":
                        setpayInfoVisible(true);
                        break;
                    case "MSG":
                        setMsgVisible(true);
                        break;
                    case "DCL":
                        setDclrVisible(true);
                        break;
                    // case "CON":
                    //     setCfrmVisible(true);
                    //     break;
                }
            }
            tab.tabSchema.setActive(index);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        openRgstRsltModal: async (menuTp: any) => {
            modal.openModal({
                url: URLS.osci0201005s,
                params: { appInfo: { ...form.newAppDtl.getValues() } },
                size: "md",
                draggable: true,
                callback: (data) => {
                    if (data != null && data != "") {
                        if (data.rslt == "save") {
                            handler.setInit();
                        } else if (data.rslt == "sbmt") {
                            modal.closeModal();
                            navigate(URLS.osci0201003q);
                        }
                    }
                },
            });
        },
        // // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: async (appId: any, appStatCd: any) => {
            fetch.updateReceived.fetch(appId, appStatCd);
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        if (comnCdList && comnCdList.length > 0) {
            handler.changeTab(0);
        }
    }, [comnCdList]);

    useEffect(() => {
        setParam({ ...(location.state ?? {}) });
    }, [location.state]);

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: "L_CO_LCNE" }, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNo} />
                            <Group.Control {...form.newAppDtl.schema.ucrNo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNm} />
                            <Group.Control {...form.newAppDtl.schema.appTpNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.sbmtDtm} />
                            <Group.Control {...form.newAppDtl.schema.aprvDtm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appStatNm} />
                            <Group.Control {...form.newAppDtl.schema.appXpirDt} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.nregYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title
                                title={asnmtOfcrTpCd === "IP" ? "T_INSC_RSLT" : "T_VRFN_RSLT"}
                                titleSize={1}
                            ></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.appRgstVrfnRslt.schema.prcssStatCd}
                                label={asnmtOfcrTpCd === "IP" ? "L_INSC_RSLT" : "L_VRFN_RSLT"}
                                controlSize={10}
                                edit={false}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.appRgstVrfnRslt.schema.prcssRsnCn}
                                label={asnmtOfcrTpCd === "IP" ? "L_INSC_RMRK" : "L_VRFN_RMRK"}
                                controlSize={10}
                                edit={false}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.appRgstVrfnRslt.schema.rmrk} controlSize={10} edit={false} />
                        </Group.Row>
                    </Group.Section>
                    {asnmtOfcrTpCd === "IP" &&
                        form.appRgstVrfnRslt.getValue("prcssStatCd") === "IP" &&
                        atcmList.content.length > 0 && (
                            <>
                                <Group.Title title={"T_ATCM"} titleSize={2}></Group.Title>
                                <Grid {...grid.appDtlInscAtcm.grid} data={atcmList} />
                            </>
                        )}
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab
                        {...tab.tabSchema.tab}
                        onChange={(index) => {
                            handler.changeTab(index);
                        }}
                    >
                        {render.tabView()}
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
